export default "__VITE_ASSET__026a5c75__"